export default {
    fade: {
        origin: { opacity: 0 },
        destination: { opacity: 1 },
    },
    "fade-up": {
        origin: { opacity: 0, yPercent: 50 },
        destination: { opacity: 1, yPercent: 0 },
    },
};
